import { ToggletipForFilteredProxiedOpensMetrics } from 'modules/messagingInsights/constants';
import { StyledDivider, TabularNumberFont } from 'modules/productAnalytics/Styled';
import {
  formatNumberGivenValueType,
  metricSentenceCase,
  tooltipValue,
} from 'modules/productAnalytics/utils';
import { useSelector } from 'react-redux';
import { Tooltip } from 'ui/tooltip';
import { kebabCase } from 'utils/stringHelpers';
import { selectAnalyticsMetricsValueTypes } from '../selectors';
import { MetricDefinitionWrapper } from './MetricDefinitionWrapper';
import {
  MetricBreakdownContainer,
  MetricBreakdownHeaderContainer,
  MetricBreakdownHeaderTitle,
  MetricBreakdownHeaderValue,
  MetricBreakdownRowWithTwoUnequalColumns,
  MetricList,
  MetricRow,
  StyledListContainer,
} from './Styled';

export const MetricBreakdown = ({
  metricGrid,
  headerChart,
  grayscale,
  halfWidth,
  headerMetric = {},
  showHeaderMetric = true,
  horizontalLayout = false,
  children,
}) => {
  const valueTypes = useSelector(selectAnalyticsMetricsValueTypes);
  const { name = '', value, key = '' } = headerMetric;
  const headerMetricTooltipValue = tooltipValue(name, value);
  return (
    <MetricBreakdownContainer grayscale={grayscale} halfWidth={halfWidth}>
      {showHeaderMetric && (
        <MetricBreakdownHeaderContainer>
          {children}
          <MetricBreakdownRowWithTwoUnequalColumns>
            <div>
              <MetricBreakdownHeaderTitle data-test={`metric-title-${kebabCase(name)}`}>
                <MetricDefinitionWrapper metricName={name}>{name}</MetricDefinitionWrapper>
              </MetricBreakdownHeaderTitle>
              <MetricBreakdownHeaderValue data-test={`metric-value-${kebabCase(name)}`}>
                <Tooltip
                  isEnabled={!!headerMetricTooltipValue}
                  tooltipContent={headerMetricTooltipValue}
                >
                  {formatNumberGivenValueType(valueTypes[key], value) || 'N/A'}
                </Tooltip>
              </MetricBreakdownHeaderValue>
            </div>
            {headerChart}
          </MetricBreakdownRowWithTwoUnequalColumns>
        </MetricBreakdownHeaderContainer>
      )}
      {!horizontalLayout && <StyledDivider />}
      <StyledListContainer useHorizontalCardPadding={!showHeaderMetric ? false : horizontalLayout}>
        {metricGrid.map((metricList, idx) => (
          <MetricList grayscale={grayscale} key={`metric-row-${idx}`}>
            {metricList.map((metric) => {
              const tooltipMetricValue = tooltipValue(metric.name, metric.value);
              const tooltip = ToggletipForFilteredProxiedOpensMetrics[metric.name];
              return (
                <MetricRow key={metric.name}>
                  <Tooltip isEnabled={!!tooltip} isUnderlined tooltipContent={tooltip}>
                    <MetricDefinitionWrapper metricName={metric.name}>
                      <span data-test={`metric-title-${kebabCase(metric.name)}`}>
                        {metricSentenceCase(metric.name)}
                      </span>
                    </MetricDefinitionWrapper>
                  </Tooltip>
                  <Tooltip isEnabled={!!tooltipMetricValue} tooltipContent={tooltipMetricValue}>
                    <TabularNumberFont data-test={`metric-value-${kebabCase(metric.name)}`}>
                      {formatNumberGivenValueType(valueTypes[metric.key], metric.value) || 'N/A'}
                    </TabularNumberFont>
                  </Tooltip>
                </MetricRow>
              );
            })}
          </MetricList>
        ))}
      </StyledListContainer>
    </MetricBreakdownContainer>
  );
};
